module.exports = __webpack_public_path__ + "img/funding-jp-method.54de851c.jpg";